module.exports = __webpack_public_path__ + "img/l13.f1b1a230.jpg";